// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionView
export default QuestionView = (function () {
  QuestionView = class QuestionView extends (
    require("lib/static-shim").default(require("lib/core/item-view").default)
  ) {
    static initClass() {
      this.prototype.template = require("assessments/admin/views/templates/question.html")

      this.prototype.behaviors = { MathJax: {} }

      this.prototype.events = {
        "click a.edit": "editQuestion",
        "click a.delete": "deleteQuestion"
      }
    }

    initialize() {
      return this.listenTo(this.model, "change:order", this.render)
    }

    editQuestion() {
      return this.trigger("state-change", "edit")
    }

    deleteQuestion() {
      return this.trigger("state-change", "delete")
    }
  }
  QuestionView.initClass()
  return QuestionView
})()
